import React from 'react'
import { Container, Loader } from './styles'
const Loading: React.FC = () => {
    return (
        <Container>
            <Loader />
        </Container>
    )
}

export default Loading
